import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-Tss-Grid',
  template: `
    <p>
      tss-grid works!
    </p>
  `,
  styles: []
})
export class TssGridComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
